<template>
  <div>
    <WarningNotice v-if='props.warn' :class='[props.limitWidth ? "max-w-[80rem]" : ""]'>
      <template #title>
        {{ props.message }}
      </template>
    </WarningNotice>
    <slot v-else />
  </div>
</template>

<script setup>

import WarningNotice from '@/components/notices/warning-notice.vue';

const props = defineProps({
  warn: Boolean,
  limitWidth: Boolean,
  message: {
    type: String,
    default: 'No results to display.'
  }
});

</script>